document.addEventListener('DOMContentLoaded', function() {
    const slidesWrappers = document.querySelectorAll('.collection.auto-slide');
    
    slidesWrappers.forEach(slidesWrapper => { // Loop through each `.collection.auto-slide`
        const time = parseFloat(slidesWrapper.getAttribute('timer')) || 3; // Get timer from each section
        
        const sliders = slidesWrapper.querySelectorAll('.grid.product-grid.contains-card.contains-card--product'); // Only inside this wrapper

        sliders.forEach(slider => {
            const childElements = slider.children;
            if (childElements.length === 0) return;

            const scrollStep = childElements[0].clientWidth;
            let scrollPosition = 0;
            let isManualScroll = false;
            const viewportWidth = window.innerWidth / 2;

            slider.addEventListener('scroll', () => {
                isManualScroll = true;
                scrollPosition = Math.round(slider.scrollLeft / scrollStep) * scrollStep;
            });

            setInterval(() => {
                if (!isManualScroll) {
                    scrollPosition += scrollStep;

                    if (scrollPosition >= slider.scrollWidth - viewportWidth) {
                        scrollPosition = 0;
                    }

                    slider.scrollTo({
                        left: scrollPosition,
                        behavior: 'smooth',
                    });
                } else {
                    isManualScroll = false;
                }
            }, time * 1000);
        });
    });
});
